import { useEffect, useState } from "react"
import prodSituazione_fetch from "../fetch/prodSituazione_fetch"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faEye, faFileLines } from "@fortawesome/free-solid-svg-icons"
import { format } from "date-fns"
import TabellaPaginazione from "../riutilizabili/TabellaPaginazione"
import InfoModal from "../riutilizabili/InfoModal"
import ReadCampiBolla from "../bolla/sezioni/ReadCampiBolla"



export default function TabProdSezioniOld({prodottoId}) {
    const [array , setArray] = useState([])
    const [viewBolla , setViewBolla] = useState(false);
    const [viewBollaUscita , setViewBollaUscita] = useState(false);
    const [pageTot , setPageTot] = useState(1);

    useEffect(()=>{
        readStorico()
    },[])


    const readStorico = async () => {
        const response = await prodSituazione_fetch.readProdSituazioneOld({soloMagazzino : 1 , prodottoId})
        console.log(response.data , ' readStorico');
        setArray(response.data)
        
    }

    const formato = "dd/MM/yyyy HH:mm"; 

    const columns = [
        {
            label: 'Data registrazione',
            nome: 'dataOra',
            altCol: (item)=> !item?.bollaUscita ? (!item?.bollaEntrata?.dataCreate ? '' : format(item.bollaEntrata.dataCreate ,formato)) : (!!item?.bollaUscita?.dataCreate ? format(item?.bollaUscita.dataCreate , formato) : '')
        },
        {
            label: 'Descrizione',
            nome: 'descrizione',
            altCol: (item)=> item?.infoProd?.descrizioneBreve
        },
        {
            label: 'Quantità',
            nome: 'quantita',
            altCol: (item)=> {
                return item?.bollaUscita ? '-'+item.quantita :  '+'+item.quantita 
            }
            
        },
        {
            label: 'Fornitore/CLiente',
            nome: 'Posizione',
            altCol: (item)=> {
                //console.log(item , ' item');
                
                return !item?.bollaUscita ? (!item?.bollaEntrata ? '' : item.bollaEntrata.mittente.viewName) : (!!item?.bollaUscita ? item?.bollaUscita.mittente.viewName : '')
            }
        },
        {
            label: 'Magazzino',
            nome: 'Posizione',
            altCol: (item)=> {
                return item?.infoSezione ?  item.infoSezione.nome  : ''
            }
        },
        {
            label: 'Tipo',
            nome : 'tipo',
            altCol: (item)=> {
                return item?.bollaUscita ?  'DDT in uscita'  : (item?.bollaEntrata ? 'DDT in entrata ' : item.nmeCausale)
            }
        },
        {
            label: 'Documento',
            nome: 'BollaEntrata',
            altCol: (item)=> {
                return (
                    item?.bollaUscita ? 
                    <span className="d-flex justify-content-center">
                        {!!item?.bollaUscita ? 
                        <span>
                            {item?.bollaUscita?.idProg  + '/' + item?.bollaUscita?.annoId+' - '+( !!item?.bollaUscita?.dataOraPartenza && format(item?.bollaUscita?.dataOraPartenza, formato))}
                        </span>
                            : ''
                        }
                            <button onClick={()=>setViewBollaUscita(item.bollaUscita)} className="btn py-0 my-0 pb-1">
                                <FontAwesomeIcon icon={faEye} />
                            </button>
                    </span>

                    : (item?.bollaEntrata ?
                        <span className="d-flex justify-content-center">
                            <span>
                                {item?.bollaEntrata?.numero+' - '+ (!!item?.bollaEntrata?.dataOraPartenza && format(item?.bollaEntrata?.dataOraPartenza, formato))}
                            </span>
                            <button onClick={()=>setViewBolla(item.bollaEntrata)} className="btn py-0 my-0 pb-1">
                                <FontAwesomeIcon icon={faEye} />
                            </button>
                        </span>
                        : ''
                    )
                    
                )
            }
        },
        // {
        //     label: 'BollaUscita',
        //     nome: 'BollaUscita',
        //     altCol: (item)=> {
        //         return !!item?.bollaUscita ? (item?.bollaUscita?.id + '/' + item?.bollaUscita?.annoId+' - '+( !!item?.bollaUscita && format(item?.bollaUscita?.dataCreate, formato))) : ''
        //     }
        // },
    ]

    const convertiData = (data) => {
            //console.log(format(new Date(data) ,'dd-MM-yyyy hh:mm') , ' Date ' , data);
            //console.log(data ,' Date 2' , (data+'').indexOf('Z'));
            if ((data+'').indexOf('Z') !== -1) {
                return format(new Date(data) ,'dd-MM-yyyy hh:mm') 
            }
            return format(new Date(data) ,'dd-MM-yyyy') 
    }

    
    return(
        <div className='p-2'>
            <TabellaPaginazione
                colonne={columns}
                dati={array}
                totalePag={pageTot}
                impaginazione={null}
                filtroTopTable
                classi=' ms-0 ps-0 '
            />

            {!!viewBolla && 
                <InfoModal
                    size='xl'
                    title={'Ddt n° ' +viewBolla.numero}
                    text={
                        <ReadCampiBolla inputs={viewBolla} infoAddView={false}/>
                    }
                    canClose
                    handleClose={()=>setViewBolla(false)}
                    className = 'modal-lg'
                />
            }

            {!!viewBollaUscita && 
                <InfoModal
                    title={ 
                    <h3 className="text-white d-flex align-items-center ps-3" >
                        <FontAwesomeIcon className="me-3 text-white" icon={faFileLines} />
                        DDT N° { viewBollaUscita?.id+'/'+viewBollaUscita?.annoId+(!!viewBollaUscita?.codiceMag ? ' - '+viewBollaUscita.codiceMag : '') + ' del ' +convertiData(viewBollaUscita?.dataFattura) }
                    </h3>
                    }
                    text={
                        <ReadCampiBolla inputs={viewBollaUscita} cliente={true} />
                    }
                    canClose
                    handleClose={()=>setViewBollaUscita(false)}
                    className = 'modal-xl'
                />
            }
        </div>
    )
}